import { render, staticRenderFns } from "./getWriterView.vue?vue&type=template&id=11050186&scoped=true&"
import script from "./getWriterView.vue?vue&type=script&lang=js&"
export * from "./getWriterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11050186",
  null
  
)

export default component.exports